import { ofType, combineEpics } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import { refundPayment } from "@/APIClient";
import {
  refundPaymentStarted,
  refundPaymentSucceeded,
  refundPaymentFailed,
  PAYMENT_MODIFICATION_PRE_AUTH_SUCCEEDED,
  PAYMENT_MODIFICATION_TYPES,
  clearRefundError,
  clearModificationPreAuthError,
  CLOSE_VOID_REFUND_MODAL,
  paymentPageAlertBarAction,
  closeVoidRefundModal,
} from "../Payment.state";
import { requestEpic } from "@/APIClient/observable.util";
import { addAlert, clearAlerts } from "@/components/alert-bar/AlertBar.state";

const clearFormEpic = (action$) =>
  action$.pipe(
    ofType(CLOSE_VOID_REFUND_MODAL),
    RxOp.mergeMap(() => Rx.of(clearRefundError(), clearModificationPreAuthError()))
  );

const refundPaymentEpic = (action$) =>
  action$.pipe(
    ofType(PAYMENT_MODIFICATION_PRE_AUTH_SUCCEEDED),
    RxOp.filter(
      ({ payload: { modificationType } }) =>
        modificationType === PAYMENT_MODIFICATION_TYPES.REFUND
    ),
    RxOp.mergeMap(({ payload: { paymentId, partialRefundItems, token } }) =>
      Rx.concat([
        Rx.of(refundPaymentStarted()),
        requestEpic({
          requestMethod: refundPayment,
          requestArgs: {
            token,
            paymentId,
            partialRefundItems: partialRefundItems,
          },
          onSuccess: (res) =>
            Rx.of(
              refundPaymentSucceeded({ payment: res.value }),
              closeVoidRefundModal(),
              paymentPageAlertBarAction(clearAlerts()),
              paymentPageAlertBarAction(
                addAlert({
                  heading: "Transaction Refunded",
                  text: `Transaction ${S.fromMaybe("")(
                    S.map(S.show)(res.value.id)
                  )} has been successfully refunded.`,
                  variant: "success",
                })
              )
            ),
          onFailure: (err) =>
            Rx.of(
              refundPaymentFailed({ error: err }),
              closeVoidRefundModal(),
              paymentPageAlertBarAction(clearAlerts()),
              paymentPageAlertBarAction(
                addAlert({
                  heading: "Transaction Refund Unsuccessful",
                  text: `Transaction ${paymentId} could not be refunded`,
                  variant: "error",
                })
              )
            ),
        }),
      ])
    ),
    RxOp.concatAll(),
    RxOp.catchError((err) => refundPaymentFailed({ error: err.message }))
  );

const epic = combineEpics(refundPaymentEpic, clearFormEpic);

export default epic;
